module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-9-bc3f98c79cb0b724360ba81bc78c2bd4.png";